module.exports = __webpack_public_path__ + "img/sending_1.3f519808.png";